<script setup lang="ts">
import { onMounted } from "vue";
import { useUIStore } from "@/stores/ui";
import { useAuthStore } from "@/stores/auth";
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";

const ui = useUIStore();
const auth = useAuthStore();

onMounted(async () => {
  // Apply persisted locale to the lang attribute.
  document.documentElement.lang = ui.locale;
  // Pre-warm auth state so guards don't have to wait on first navigation.
  await auth.hydrate();
});
</script>

<template>
  <RouterView />
  <Toast position="top-right" />
  <ConfirmDialog />
</template>
